import { cleanImportWarnings, normalizeAddress } from './builtProjectUtils';

export const BUILT_IMPORT_VERSION = 2;

export function validateBuiltImportManifest(manifest) {
  if (!manifest || manifest.version !== BUILT_IMPORT_VERSION || !Array.isArray(manifest.entries)) {
    throw new Error('This is not a supported built-home import package.');
  }

  manifest.entries.forEach((entry, index) => {
    if (!entry || typeof entry !== 'object') throw new Error(`Entry ${index + 1} is invalid.`);
    if (!entry.sourceFolderName) throw new Error(`Entry ${index + 1} has no source folder name.`);
    if (!entry.sourceImportKey) throw new Error(`Entry ${index + 1} has no source import key.`);
    const reviewTarget = entry.sourceDocumentHash || entry.sourceImportKey;
    if (entry.agentReview?.status !== 'approved' || entry.agentReview?.target !== reviewTarget) {
      throw new Error(`Entry ${index + 1} has not passed the required agent review for its current source document.`);
    }
    if (entry.consentedDate && !/^\d{4}-\d{2}-\d{2}$/.test(entry.consentedDate)) {
      throw new Error(`Entry ${index + 1} has an invalid consentedDate.`);
    }
    if (entry.allowSharedAddress !== undefined && typeof entry.allowSharedAddress !== 'boolean') {
      throw new Error(`Entry ${index + 1} has an invalid allowSharedAddress value.`);
    }
    const plansPdf = entry.plansPdf || entry.evidencePdf;
    if (plansPdf && (!plansPdf.path || !Array.isArray(plansPdf.pageNumbers))) {
      throw new Error(`Entry ${index + 1} has invalid plans PDF metadata.`);
    }
  });

  return manifest;
}

export function prepareBuiltImportEntry(entry) {
  return {
    ...entry,
    address: String(entry.address || '').trim(),
    addressKey: String(entry.addressKey || normalizeAddress(entry.address)).trim(),
    buildStyle: String(entry.buildStyle || '').trim(),
    clientName: String(entry.clientName || entry.sourceFolderName || '').trim(),
    allowSharedAddress: entry.allowSharedAddress === true,
    importWarnings: cleanImportWarnings(entry.importWarnings),
    plansPdf: entry.plansPdf || entry.evidencePdf || null,
  };
}

export function isCuratedSiblingRecord(entry, matchedHome) {
  return entry.allowSharedAddress === true
    && matchedHome?.get('sourceFolderName') === entry.sourceFolderName
    && matchedHome?.get('sourceImportKey') !== entry.sourceImportKey;
}

export function isApprovedSharedAddressMatch(entry, matchedHome) {
  return entry.allowSharedAddress === true
    && Boolean(matchedHome)
    && matchedHome.get('sourceImportKey') !== entry.sourceImportKey;
}

export function createBuiltMapRecord(importResult) {
  return {
    version: 1,
    sourceImportKey: importResult.sourceImportKey,
    builtHomeObjectId: importResult.builtHomeObjectId,
    clientName: importResult.clientName || '',
    address: importResult.address || '',
    consentedDate: importResult.consentedDate || '',
    sourcePlan: importResult.sourcePlanPath || '',
    status: importResult.status,
    processedAt: importResult.processedAt,
  };
}
